import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next'; // Add this import
import backgroundImage from '../../images/section-2-bg.png';
import backgroundImageSmall from '../../images/section-2-mobile.png';
import { Helmet } from 'react-helmet';
import fs3 from '../../images/fs-3.png';
import { Button } from 'components';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

export const Section2 = () => {
  const { t } = useTranslation(); // Hook for translations
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <Helmet>
        <title>Solutions & Installation — Sonnen Raffstoren</title>
        <meta
          name="description"
          content="Learn about Sonnen Raffstoren GmbH’s solutions and installation approach. Section two highlights our range of products, the technical benefits of exterior blinds, and the installation workflows we follow to ensure accuracy and performance. We provide structural assessments, custom mounting solutions and integration with building facades while maintaining aesthetic quality. Our teams use proven installation techniques, documented processes and a focus on safety and weatherproofing to deliver long-lasting results. Clients receive clear timelines, communication and post-installation support. Choose from manual, motorized or fully automated options with smart controls for enhanced usability and efficiency."
        />
      </Helmet>
      <section
        className="flex flex-col-reverse md:flex-row items-center justify-between px-smallPx md:px-mediumPx lg:px-largePx xl:px-[200px] xl:h-[530px] md:space-y-0 py-20"
        style={{
          backgroundImage: `url(${isSmallScreen ? backgroundImageSmall : backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <motion.div
          className="content-center space-y-6 md:w-[70%] py-10"
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div>
            <h1 className="text-[24px] font-bold text-[#1E90AA]">
              {t('section2.title1')}
            </h1>
            <p className="md:ml-5">{t('section2.paragraph1')}</p>
          </div>
          <div>
            <h1 className="text-[24px] font-bold text-[#1E90AA]">
              {t('section2.title2')}
            </h1>
            <p className="md:ml-5">{t('section2.paragraph2')}</p>
          </div>
          <Button
            text={t('section2.button')}
            className="text-white hover:text-black"
            onClick={() => navigate('/about')}
          />
        </motion.div>
        <motion.img
          src={fs3}
          className="h-[300px] w-[300px] mb-10 md:mb-0"
          alt={t('section2.imageAlt')}
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        />
      </section>
    </>
  );
};

export default Section2;
